import React from "react";
import { Col } from "react-bootstrap";
import { TextareaField } from "../Fields/TextareaField";
import { requiredField } from "../Validation";

export const DescriptionField = ( props ) => {
    return <Col md={ 12 }>
        <TextareaField
            fieldId={ props.parent }
            fieldLabel="Description"
            fieldRequired={ true }
            validator={ requiredField }
        />
    </Col>;
}